"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var ListItemIconComponent = function ListItemIconComponent(_ref) {
  var className = _ref.className,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["className"]);
  return _react["default"].createElement(_ListItemIcon["default"], (0, _extends2["default"])({}, restProps, {
    className: (0, _classnames["default"])(className, 'pr-3')
  }));
};

ListItemIconComponent.propTypes = {
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
};
var _default = ListItemIconComponent;
exports["default"] = _default;